// eslint-disable-next-line import/no-internal-modules
import Icon from '@insided/deprecated-preact-components/assets'
import TeamNotesLastEdited from './TeamNotesLastEdited'

interface Props {
  updatedBy?: string
  updatedAt?: string
  isLoading: boolean
}

const TeamNotesMetadata = ({ updatedBy, updatedAt, isLoading }: Props) => (
  <div className='team-notes__metadata'>
    <div>
      <Icon
        icon='lock'
        width={16}
        height={16}
      />
      <div className='team-notes__metadata-visibility'>Only visible in control</div>
    </div>
    {updatedAt && updatedBy
      ? <TeamNotesLastEdited
          updatedBy={updatedBy}
          updatedAt={updatedAt}
          isLoading={isLoading}
        />
      : null}
  </div>
)

export default TeamNotesMetadata
